module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "gray-back",
    staticStyle: {
      "height": "100%"
    }
  }, [_c('div', {
    staticClass: "box"
  }, [_c('van-tabs', {
    staticClass: "tab-nav",
    attrs: {
      "sticky": ""
    },
    on: {
      "click": _vm.onStatusChange
    },
    model: {
      value: (_vm.active),
      callback: function($$v) {
        _vm.active = $$v
      },
      expression: "active"
    }
  }, [_c('van-tab', {
    attrs: {
      "title": "报名中"
    }
  }), _vm._v(" "), _c('van-tab', {
    attrs: {
      "title": "报名成功"
    }
  }), _vm._v(" "), _c('van-tab', {
    attrs: {
      "title": "全部"
    }
  }), _vm._v(" "), _c('van-pull-refresh', {
    on: {
      "refresh": _vm.onRefresh
    },
    model: {
      value: (_vm.isLoading),
      callback: function($$v) {
        _vm.isLoading = $$v
      },
      expression: "isLoading"
    }
  }, [_c('van-list', {
    attrs: {
      "finished": _vm.finished,
      "finished-text": "没有更多了"
    },
    on: {
      "load": _vm.onLoad
    },
    model: {
      value: (_vm.loading),
      callback: function($$v) {
        _vm.loading = $$v
      },
      expression: "loading"
    }
  }, _vm._l((_vm.list), function(order, index) {
    return _c('div', {
      key: index,
      staticClass: "row-list",
      on: {
        "click": function($event) {
          return _vm.goDetail(order)
        }
      }
    }, [_c('div', {
      staticClass: "justify-space-flex row-title"
    }, [_c('div', {
      staticClass: "title-left flex-start gray"
    }, [_c('img', {
      staticClass: "row-title-img",
      attrs: {
        "src": "https://static.dierqudao.com/images/dinghuoxitong/icon-date.png",
        "alt": ""
      }
    }), _vm._v(" "), _c('span', [_vm._v(_vm._s(order.create_time_str))])]), _vm._v(" "), (order.memberstatus == 1) ? _c('div', {
      staticClass: "title-right gray"
    }, [_vm._v("\n                                    秩序册\n                                ")]) : (order.memberstatus == 2) ? _c('div', {
      staticClass: "title-right gray"
    }, [_vm._v("\n                                    项目填写\n                                ")]) : (order.memberstatus == 3) ? _c('div', {
      staticClass: "title-right gray"
    }, [_vm._v("\n                                    人员统计\n                                ")]) : (order.memberstatus == 4) ? _c('div', {
      staticClass: "title-right gray"
    }, [_vm._v("\n                                    住宿统计\n                                ")]) : (order.memberstatus == 5) ? _c('div', {
      staticClass: "title-right"
    }, [_vm._v("\n                                    等待付款\n                                ")]) : (order.memberstatus == 6) ? _c('div', {
      staticClass: "title-right green"
    }, [_vm._v("\n                                    报名成功\n                                ")]) : (order.memberstatus == -1) ? _c('div', {
      staticClass: "title-right gray"
    }, [_vm._v("\n                                    弃权\n                                ")]) : (order.memberstatus == -2) ? _c('div', {
      staticClass: "title-right gray"
    }, [_vm._v("\n                                    待审核\n                                ")]) : (order.memberstatus == -3) ? _c('div', {
      staticClass: "title-right"
    }, [_vm._v("\n                                    审核失败\n                                ")]) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "justify-space-flex row-goods"
    }, [_c('div', {
      staticClass: "row-left flex-start"
    }, [_c('div', {
      staticClass: "goods-detail"
    }, [_c('div', {
      staticClass: "goods-name"
    }, [_vm._v(_vm._s(order.saiqu_name))]), _vm._v(" "), _c('div', {
      staticClass: "goods-weight gray-light"
    }, [_vm._v("\n                                            " + _vm._s(order.mingcheng) + "\n                                        ")])])]), _vm._v(" "), _c('div', {
      staticClass: "row-right"
    }, [_c('div', {
      staticClass: "goods-price"
    }, [_c('span', [_vm._v("¥")]), _vm._v(_vm._s(order.total_price))]), _vm._v(" "), _c('div', {
      staticClass: "goods-num gray-light"
    }, [_vm._v("参赛人数 " + _vm._s(order.membercount))]), _vm._v(" "), _c('div', {
      staticClass: "goods-num gray-light"
    }, [_vm._v("食宿缴费人数 " + _vm._s(order.shisu_jf_count))])]), _vm._v(" "), (order.is_offline_un_pay) ? _c('van-notice-bar', {
      attrs: {
        "wrapable": "",
        "scrollable": false,
        "text": "线下付款需要管理员审核，请耐心等待2个工作日左右"
      }
    }) : _vm._e()], 1), _vm._v(" "), _c('div', {
      staticClass: "row-btn"
    }, [(order.show_upload_video) ? _c('div', {
      staticClass: "look-order"
    }, [_vm._v("上传视频")]) : _vm._e(), _vm._v(" "), (order.memberstatus == 6 && order.is_jizan == 1) ? _c('div', {
      staticClass: "look-order"
    }, [_vm._v("上传集赞")]) : _vm._e(), _vm._v(" "), (order.have_cert) ? _c('div', {
      staticClass: "look-order"
    }, [_vm._v("下载证书")]) : _vm._e(), _vm._v(" "), (order.have_bu) ? _c('div', {
      staticClass: "look-order",
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.orderBu(order)
        }
      }
    }, [_vm._v("补缴费用")]) : _vm._e(), _vm._v(" "), ((order.memberstatus != 6 && (order.saiqu != 751 || order.saiqu != 767)) || (order.memberstatus == 6 && (order.saiqu == 768 || order.saiqu == 803))) ? _c('div', {
      staticClass: "look-order",
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.beizhu(order)
        }
      }
    }, [_vm._v("支付凭证上传")]) : _vm._e(), _vm._v(" "), (order.memberstatus == 6) ? _c('div', {
      staticClass: "look-order",
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.successInfo(order)
        }
      }
    }, [_vm._v("详情")]) : _vm._e(), _vm._v(" "), (order.memberstatus != 6) ? _c('div', {
      staticClass: "look-order",
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.onDelete(order)
        }
      }
    }, [_vm._v("删除")]) : _vm._e(), _vm._v(" "), (order.memberstatus == 6) ? _c('div', {
      staticClass: "look-order",
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.kaipiao(order)
        }
      }
    }, [_vm._v("申请开票")]) : _vm._e()])])
  }), 0)], 1)], 1)], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-e3fd7b44","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/page/apps/isai/SaiApplyList.vue
// module id = 2614
// module chunks = 0